import { render } from "./ProcessEvent.vue?vue&type=template&id=01eb9933"
import script from "./ProcessEvent.vue?vue&type=script&lang=js"
export * from "./ProcessEvent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__